import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Can you book emergency train tickets and tatkal seats?",
    a: "Yes, we assist with Tatkal IRCTC bookings, premium trains, and urgent flight sectors with swift turnaround.",
  },
  {
    q: "Do you assist with international tourist visas and appointments?",
    a: "Yes, our visa desk provides full documentation scrutiny, embassy appointment scheduling, and guidance for Dubai, Schengen, UK, US, Singapore, Thailand, and more.",
  },
  {
    q: "Can tour packages be customized for family or senior citizens?",
    a: "Every tour package is tailored to your preferred pace, hotel comfort level, meal preferences, and vehicle requirements.",
  },
];

export const Faq = () => (
  <section className="py-20 bg-stone-100 border-b border-stone-200" data-testid="faq-section">
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-14">
        <span className="text-xs font-bold tracking-widest text-amber-800 uppercase">Got Questions?</span>
        <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-stone-900 mt-2 font-serif-display">
          Frequently Asked Questions
        </h2>
      </div>

      <Accordion type="single" collapsible className="space-y-4">
        {FAQS.map((f, i) => (
          <AccordionItem
            key={f.q}
            value={`faq-${i}`}
            className="bg-white rounded-xl px-6 border border-stone-200"
            data-testid={`faq-item-${i + 1}`}
          >
            <AccordionTrigger className="text-base font-bold text-stone-900 text-left hover:no-underline py-5">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-xs text-stone-600 leading-relaxed pb-5">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);
